
<app-nav />

<div [class.container-fluid]="isWidescreen()" [class.container]="!isWidescreen()">
  <router-outlet />
</div>

<rs-load-indicator />
<rs-toast />
